export default "__VITE_ASSET__BEIVlLKP__"